<template>
  <div class="messages">
    <div class="container pb-0">
      <MessageComponent
        v-for="(message, index) of msgs"
        :key="message.time.getMilliseconds()"
        class="message"
        :message="message"
        :message-index="index"
        :style="`opacity: ${index === 0 ? 0.95 : 1.5 / (index + 1)}`"
        @remove="removeMsg(index)"
        @click="message.secondsVisible > -1 ? removeMsg(index) : 0"
      />

      <!-- <button v-if="!store.messages.length" @click="restoreTestMsgs()">restore test msgs</button> -->
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, defineComponent, ref } from 'vue'
import MessageComponent from '@/components/messages/AlertMessageComponent.vue'
import { useDefaultStore } from '@/store'
import Message from '@/models/Message'

const store = useDefaultStore()

const msgs = computed(() => store.messages.slice(0, 3))

const removeMsg = (index: number) => {
  store.removeMessage(index)
}

const restoreTestMsgs = () => {
  store.addMessage(
    new Message(
      'test2',
      'kunde inte göra\nkunde inte göra\nkunde inte göra\nkunde inte göra\nkunde inte göra\nkunde inte göra\nkunde inte göra\nkunde inte göra\nkunde inte göra\nkunde inte göra\nkunde inte göra\nkunde inte göra',
      'warning',
    ),
  )
  store.addMessage(new Message('test1', 'en rad\n rad två', 'warning'))
  // store.addMessage(new Message('test3', 'beskrivning beskrivning beskrivning beskrivning beskrivning beskrivning', 'success', 20))
  // store.addMessage(new Message('test4', undefined, 'warning', 4))
}
</script>

<style lang="scss" scoped>
.messages {
  z-index: 1060;
  position: fixed;
  bottom: 0;
  width: 100%;
  display: inline-block;
}

.container {
  display: flex;
  flex-direction: column-reverse;
}
</style>
